import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import NotFound from "../views/NotFound.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/most-urgent",
    name: "MostUrgent",
    // route level code-splitting
    // this generates a separate chunk (most-urgent.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../views/MostUrgent.vue")
  },
  
  // { path: "*", redirect: "/"} // old version
  
  // Separated into two routes so that you can also programmatically
  // direct the user to the /404 if missing some data, etc.
  { 
    path: "/404", 
    component: NotFound 
  },
  { 
    path: "*", 
    redirect: "/404" 
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
